import { lowerCase } from 'es-toolkit'
import DXFFileLoader from './dxf-file-loader'
import GCodeFileLoader from './gcode-file-loader'
import OBJFileLoader from './obj-file-loader'
import STLFileLoader from './stl-file-loader'
import STEPFileLoader from './step-file-loader'
import ThreeMFFileLoader from './threemf-file-loader'

class FileLoader {
  constructor(private readonly file: File) { }

  async load() {
    const Loader = this.getLoader()
    const loaderInstance = new Loader(this.file)
    return loaderInstance.load()
  }

  private getLoader() {
    switch (this.getFileExtension()) {
      case '3mf':
        return ThreeMFFileLoader
      case 'dxf':
        return DXFFileLoader
      case 'mpp':
      case 'mxp':
        return GCodeFileLoader
      case 'obj':
        return OBJFileLoader
      case 'stl':
        return STLFileLoader
      case 'stp':
      case 'step':
        return STEPFileLoader
      default:
        throw new Error('Unsupported file type')
    }
  }

  private getFileExtension() {
    return lowerCase(this.file.name.split('.').at(-1) ?? '').replace(/ /g, '')
  }
}

export default FileLoader
